import React from "react";
import { Route } from "react-router-dom";

import { ManualOrdersCard } from "./ManualOrdersCard";

export function ManualOrdersPage({ history }) {


  return (
    <>
        {/* <Route path="/pedidos-manuales/new">
            {({ history, match }) => (
            <CustomerEditDialog
                show={match != null}
                onHide={() => {
                history.push("/clientes");
                }}
            />
            )}
        </Route>
        <Route path="/pedidos-manuales/:id/edit">
            {({ history, match }) => (
            <CustomerEditDialog
                show={match != null}
                id={match && match.params.id}
                onHide={() => {
                history.push("/clientes");
                }}
            />
            )}
        </Route> */}
        <ManualOrdersCard />
      </>

  );
}
